<script>
import {BCard, BCardTitle, BFormGroup, BRow, BCol } from 'bootstrap-vue'
import BusinessRule from "@/views/administration/legislation/components/BusinessRule.vue";
import vSelect from 'vue-select'
import Overlay from "@core/components/common/Overlay.vue";
import {LegislationApi} from "@core/api";
import {legislationTranslationMixin} from "@core/domain/legislation";
import {Button} from "@core/components/common";
import EventStatus from "@/views/administration/legislation/components/EventStatus.vue";

export default {
    mixins: [legislationTranslationMixin],
    components: {BusinessRule, BCard, BCardTitle, BFormGroup, vSelect, Overlay, BRow, BCol, Button, EventStatus},
    props: {
        legislation: {
            type: Object
        }
    },
    data() {
        return {
            showLoading: true,
            events: [],
            statuses: [],
            selectedEvent: null,
            availableEvents: [],

            map: []
        }
    },
    computed: {

    },
    methods: {
        onEventSelected() {
            this.map.push({
                event: this.selectedEvent.id,
                status: null
            });
            this.$emit('add', this.selectedEvent);
            this.selectedEvent = null;
            this.recalculateAvailableEvents();
        },
        recalculateAvailableEvents() {
            this.availableEvents = this.events.filter(e => !this.legislation.eventStatuses.hasOwnProperty(e.id));
        },
        makeStatusValue(status) {
            return {
                id: status,
                title: this.$t(this.makeProductStatusTranslationKey(status))
            }
        },
        remove(event) {
            if (this.legislation.eventStatuses.hasOwnProperty(event)) {
                delete this.legislation.eventStatuses[event];
                this.recalculateAvailableEvents();
            }
            let index = this.map.findIndex(es => es.event === event);

            if (index >= 0) {
                this.map.splice(index, 1);
            }
        },
        change(event, status) {
            let index = this.map.findIndex(es => es.event === event);

            if (index >= 0) {
                this.map[index].status = status
                this.legislation.eventStatuses[event] = status;
            }
        }
    },
    created() {
        Promise.all([
            LegislationApi.getProductStatuses().then(r => this.statuses = r.data.map(s => this.makeStatusValue(s))),
            LegislationApi.getProductEvents().then(r => {
                this.events = r.data.map(e => {
                    return {
                        id: e,
                        title: this.$t(this.makeProductEventTranslationKey(e))
                    }
                });
                this.recalculateAvailableEvents();
            })
        ]).finally(() => this.showLoading = false)
    },
    watch: {
        legislation() {
            this.recalculateAvailableEvents();
            this.map = Object.keys(this.legislation.eventStatuses).map(event => {
                return {
                    event: event,
                    status: this.legislation.eventStatuses[event]
                };
            });

        }
    }
}
</script>

<template>
    <Overlay :show="showLoading">
        <b-card no-body>
            <div class="card-header">
                <div class="col-md-12 pl-0">
                    <b-card-title>
                        {{ $t('Page(LegislationCard):Component(Text):event-status-management') }}
                    </b-card-title>
                </div>
            </div>
            <div class="pl-2 pr-2 pb-1">
                <b-row>
                    <b-col>
                        <b-form-group
                            :label="$t('Component(Label):event')"
                            label-for="event"
                        >
                            <v-select
                                v-model="selectedEvent"
                                @input="onEventSelected"
                                id="event"
                                label="title"
                                :placeholder="$t('Component(Placeholder):event')"
                                :options="availableEvents"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <div v-for="eventStatus in map">
                    <EventStatus
                        :event="eventStatus.event"
                        :status="eventStatus.status"
                        :statuses="statuses"
                        @remove="remove"
                        @change="change"
                    />
                </div>
            </div>
        </b-card>
    </Overlay>
</template>
